import Seo from '../components/blog/seo'
import { fetchSEO } from '../lib/blog/api'
import { MuxVideo } from '../components/MuxVideo'
import { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faChartLine,
  faHandHoldingDollar,
  faMoneyCheck,
  faTruck,
} from '@fortawesome/free-solid-svg-icons'
import { Button } from 'react-bootstrap'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Block from '../components/landing/elements/Block'
import Card from '../components/landing/elements/Card'
import Title from '../components/landing/elements/Title'
import Text from '../components/landing/elements/Text'
import LandingWrapper from '../components/landing/elements/LandingWrapper'
import RetailersLandingForm from '../components/RetailersLandingForm'
import CalendlyEmbed from '../components/CalendlyEmbed'
import * as db from 'firebase/firestore'
import SuccessBlock from '../components/SuccessBlock'

const video = {
  width: 800,
  height: 450,
  playbackId: 'lUWLg02A2keCya5jxXQqgunn7bjXuO9qQ8P8oIod8n58'
}

const howItWorks = [
  'You become one of our resellers',
  'We market our inventory in your local area',
  'You pickup returns or get truckloads delivered',
]

const benefits = [
  { icon: faMoneyCheck, text: 'Items at 10-15% of MSRP' },
  { icon: faTruck, text: 'Buy Individual Returns or Truckloads' },
  { icon: faChartLine, text: 'Increase Profits' },
  { icon: faHandHoldingDollar, text: 'No hidden fees' },
]

const brands = [
  {
    src: '/img/landing/retailers/casterly_logo.svg',
    alt: 'Casterly | Ivy Flip Retailer Partner',
  },
  {
    src: '/img/landing/retailers/denver-modern_logo.png',
    alt: 'Denver Modern | Ivy Flip Retailer Partner',
  },
  {
    src: '/img/landing/retailers/interrior-define_logo.svg',
    alt: 'Interrior Define | Ivy Flip Retailer Partner',
  },
  {
    src: '/img/landing/retailers/lulu-and-georgia_logo.svg',
    alt: 'Lulu and Georgia | Ivy Flip Retailer Partner',
  },
]

function scrollToForm () {
  const formElement = document.getElementById('retailer-form')
  if (formElement) {
    window.scrollTo({
      top: formElement.getBoundingClientRect().top + window.scrollY - 50,
      behavior: 'smooth'
    })
  }
}

function CtaButton () {
  return (
    <div className={'d-flex'}>
      <Button
        variant="success"
        size="lg"
        className="px-5 py-3 w-100"
        onClick={scrollToForm}
      >
        Get Started
      </Button>
    </div>
  )
}

export default function RetailersLanding ({ seo }) {
  const [isPlaying, setIsPlaying] = useState(false)

  const [isSaving, setIsSaving] = useState(false)
  const [formState, setFormState] = useState('form') // 'form', 'booking', 'submitted'
  const [formError, setFormError] = useState(null)

  async function onSubmit (data) {
    setFormError(null)
    setIsSaving(true)
    try {
      await db.addDoc(db.collection(db.getFirestore(), 'resellers_landing_request'), {
        ...data,
        created_at: db.Timestamp.now()
      })

      setFormState('booking')
      scrollToForm()
    } catch (e) {
      console.error(e)
      setFormError(e.message)
    } finally {
      setIsSaving(false)
    }
  }

  return (
    <>
      <Seo seo={seo} />
      <LandingWrapper>
        {/* Intro Section */}
        <Block
          id={'intro'}
          background={'bg-primary'}
          color={'text-white'}
          fullWidth
          backgroundImage={'/img/landing/retailers/bg-resellers.jpg'}
          leftGradient
        >
          <Col xs={12} md={8}>
            <div className={'py-5 my-md-5'}>
              <Card
                gap={5}
                className={'mt-5 mt-md-4 bg-opacity-75'}
              >
                <Title size={1} h>
                  Furniture Businesses:
                  <br/>
                  looking for <span className={'text-success'}>Liquidation Inventory</span>?
                </Title>
                <div className={'d-flex flex-column gap-3'}>
                  <Text p size={5} accent>
                    Get Access to our <strong>Exclusive Returns</strong> and <strong>Liquidation Items</strong> from Top Brands!
                  </Text>
                  <Text p size={5}>
                    We've partnered with brands around the USA for access to exclusive inventory for our retailers and resellers.
                  </Text>
                  <Text p size={5}>
                    Click below to get started and get approved to become a reseller! The process is easy!
                  </Text>
                </div>
                <div className="d-flex">
                  <CtaButton />
                </div>
              </Card>
            </div>
          </Col>
        </Block>

        {/* Video Section */}
        <Block
          id={'video'}
          className={'overflow-hidden'}
        >
          <Col
            xs={12} md={10}
            className={'mx-auto'}
          >
            <Card center>
              <MuxVideo
                key={video.playbackId}
                id={video.playbackId}
                width={video.width}
                height={video.height}
                playVideo={() => setIsPlaying(!isPlaying)}
                isPlaying={isPlaying}
              />
            </Card>
          </Col>
          <Col
            xs={12}
            className={'pt-4'}
          >
            <div className={'d-flex justify-content-center'}>
              <CtaButton />
            </div>
          </Col>
        </Block>

        {/* Benefits Section */}
        <Block
          id={'benefits'}
          g={'g-3'}
        >
          {benefits.map(({ icon, text }, idx) => (
            <Col
              xs={6} md={3}
              key={idx}
            >
              <Card center>
                <FontAwesomeIcon
                  icon={icon}
                  width={72}
                  height={72}
                  className='text-success display-1'
                />
                <Text p size={5}>{text}</Text>
              </Card>
            </Col>
          ))}
        </Block>

        {/* How it works */}
        <Block
          id={'how-it-works'}
          background={'bg-light'}
        >
          <Col
            xs={12}
            className={'pt-3 pb-5'}
          >
             <Title
               h size={2} center
             >
               How It Works
             </Title>
          </Col>
          {howItWorks.map((step, index) => (
            <Col
              md={4} xs={6}
              key={index}
              className={'px-2 px-md-5'}
            >
              <Card gap={3} center>
                <div
                  className='bg-success text-white fs-3 d-flex justify-content-center align-items-center'
                  style={{width: 60, height: 60, borderRadius: '50%'}}
                >
                  {index + 1}
                </div>
                <Text p accent>
                  {step}
                </Text>
              </Card>
            </Col>
          ))}
          <Col
            xs={12}
            className={'pt-4 pb-5'}
          >
            <div className={'d-flex flex-column justify-content-center align-items-center gap-3'}>
              <Text
                p accent size={4} center
              >
                Ready to increase your furniture profits?
              </Text>
              <CtaButton />
            </div>
          </Col>
        </Block>

        {/* Brands */}
        <Block
          id='brands'
          background={'bg-primary'}
          color={'text-white'}
        >
          <Col
            xs={12}
            className={'pt-3 pb-3'}
          >
            <Title h size={2} center>
              Brands We Work With
            </Title>
          </Col>
          <Col xs={12}>
            <div className={'px-5'}>
              <Row className={'justify-content-center align-items-center g-4'}>
                {brands.map(({ src, alt }, idx) => (
                  <Col
                    xs={12} md={3}
                    key={idx}
                  >
                    <div className='bg-white p-4 br-3'>
                      <img
                        src={src}
                        alt={alt}
                        style={{ width: '100%', height: 'auto', objectFit: 'contain' }}
                      />
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          </Col>
          <Col
            xs={12}
            className={'pt-3 pb-5'}
          >
            <div className={'d-flex justify-content-center'}>
              <CtaButton />
            </div>
          </Col>
        </Block>

        {/* Form block  */}
        <Block
          id="retailer-form"
          background={'bg-light'}
        >
          <Col
            xs={12}
            md={8}
            className="mx-auto"
          >
            <Card
              className="p-3 p-md-5"
              gap={4}
            >
              <div className={'fs-2 fw-semibold'}>
                Join Our Retailer Network
              </div>

              {formError && (
                <div className={'alert alert-danger'}>
                  {formError}
                </div>
              )}

              {formState === 'form' && (
                <>
                  <div className={'fs-4'}>
                    Step 1. Fill out the form.
                  </div>

                  <RetailersLandingForm
                    onSubmit={onSubmit}
                    disabled={isSaving}
                  />
                </>
              )}

              {formState === 'booking' && (
                <>
                  <div className={'fs-4'}>
                    Step 2. Book a time to discuss your application.
                  </div>
                  <CalendlyEmbed
                    url={'https://calendly.com/ivyflip/retailer-returns-solution'}
                  />
                  <div>
                    <Button
                      variant="success"
                      size="lg"
                      onClick={() => {
                        setFormState('submitted')
                        scrollToForm()
                      }}
                    >
                      Next
                    </Button>
                  </div>
                </>
              )}

              {formState === 'submitted' && (
                <SuccessBlock
                  header={'Your request has been sent.'}
                  description={'We will review your application and get back to you soon.'}
                />
              )}
            </Card>
          </Col>
        </Block>
      </LandingWrapper>
    </>
  )
}

export async function getStaticProps () {
  const seo = await fetchSEO('resellers')
  return {
    props: { seo },
    revalidate: 60 * 60 * 24
  }
}
